import { render } from "./OrgPrivacy.vue?vue&type=template&id=2eab81ac&scoped=true"
import script from "./OrgPrivacy.vue?vue&type=script&lang=js"
export * from "./OrgPrivacy.vue?vue&type=script&lang=js"

import "./OrgPrivacy.vue?vue&type=style&index=0&id=2eab81ac&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eab81ac"]])

export default __exports__